import { createApi } from '@reduxjs/toolkit/query/react';
import { capitalizeString } from '@strata/helper-functions';
import { type IssueType } from '@strata/react-status-icons';
import { type OpportunityStatus } from '@strata/react-status-indicators';

import { OPPORTUNITY_CURATOR_API_URL } from 'api/APIBase';
import { handleError } from 'services/Error';
import { determineStatus } from 'services/opportunityHelpers';
import { getBaseQuery } from 'store/api/apiBaseQuery';

export interface OpportunitySummary {
    benefitType: string;
    issues: IssueType[];
    receivedTime: string;
    referralId: string;
    referralStatus: OpportunityStatus;
}

export const opportunityCuratorApi = createApi({
    baseQuery: getBaseQuery(OPPORTUNITY_CURATOR_API_URL),
    reducerPath: 'opportunityCuratorApi',
    endpoints: (build) => ({
        /** Gets details of opportunity */
        getOpportunityByTreatment: build.query<OpportunitySummary, { treatmentId: string }>({
            query: ({ treatmentId }) => `client/opportunities/by_treatment/${treatmentId}`,
            transformResponse: (opportunity: {
                benefit: string;
                issues: IssueType[];
                received_time: string;
                referral_id: string;
            }) => ({
                benefitType: capitalizeString(opportunity.benefit),
                issues: opportunity.issues,
                receivedTime: opportunity.received_time,
                referralId: opportunity.referral_id,
                referralStatus: determineStatus(opportunity.issues),
            }),
            transformErrorResponse: (err) => {
                if (err.status !== 404) {
                    handleError('An error occurred retrieving referral details.', err);
                }
            },
        }),
    }),
});

export const { useGetOpportunityByTreatmentQuery } = opportunityCuratorApi;
